var _a, _b;
import { __spreadArrays } from "tslib";
import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { pushPopoverWithOptions, removePopover } from './actionCreators';
export default (_a = {},
    _a[reduxKey] = handleActions((_b = {},
        _b[pushPopoverWithOptions.toString()] = function (state, action) {
            var existingPopover = state.find(function (item) { return item.id === action.payload.id; });
            if (existingPopover) {
                ddt.warn('popovers', 'Pushed a popover with an id that already exists in the array');
            }
            return __spreadArrays(state, [action.payload]);
        },
        _b[removePopover.toString()] = function (state, action) {
            return state.filter(function (item) { return item.id !== action.payload; });
        },
        _b), []),
    _a);
//# sourceMappingURL=reducer.js.map